var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64742 18.9246C8.30421 18.565 8.31746 17.9953 8.67701 17.6521L14.595 12.0031L8.67701 6.35414C8.31746 6.01094 8.30422 5.44124 8.64742 5.0817C8.99063 4.72215 9.56032 4.7089 9.91987 5.0521L16.5199 11.3521C16.6978 11.5219 16.7984 11.7572 16.7984 12.0031C16.7984 12.2491 16.6978 12.4843 16.5199 12.6541L9.91987 18.9541C9.56032 19.2973 8.99062 19.2841 8.64742 18.9246Z",
    fill: "#51ACED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.b8a2ee11621675b8e555eaba17861ac4.svg";
export { ForwardRef as ReactComponent };